import { View } from "@/components/ui";
import { ServiceIcon } from "@/components/shared/service-icon";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { serviceItemsSectionOne, serviceItemsSectionTwo } from "../lib";

export function PopularServices() {
  return (
    <Card className="border-0 bg-transparent">
      <CardContent className="flex flex-col gap-3 p-0">
        <View className="flex flex-row flex-wrap">
          {serviceItemsSectionOne().map((service, index) => (
            <View
              className={cn(
                "w-1/4",
                index === 0
                  ? "pl-0 pr-1.5"
                  : index === 3
                    ? "pl-1.5 pr-0"
                    : "px-1.5",
              )}
              key={service.name}
            >
              <ServiceIcon
                {...service}
                className="rounded-xl bg-card p-2 md:rounded-2xl"
              />
            </View>
          ))}
        </View>
        <View className="flex flex-row flex-wrap">
          {serviceItemsSectionTwo().map((service, index) => (
            <View
              className={cn(
                "w-1/4",
                index === 0
                  ? "pl-0 pr-1.5"
                  : index === 3
                    ? "pl-1.5 pr-0"
                    : "px-1.5",
              )}
              key={service.name}
            >
              <ServiceIcon
                {...service}
                className="rounded-xl bg-card p-2 md:rounded-2xl"
              />
            </View>
          ))}
        </View>
      </CardContent>
    </Card>
  );
}
